import { ExternalLink } from "lucide-react";
import { rememberPopout } from "../lib/sync";

const isPopoutMode = () =>
  typeof window !== "undefined" && new URLSearchParams(window.location.search).get("pop") === "1";

const popOut = () => {
  const url = new URL(window.location.href);
  url.searchParams.set("pop", "1");
  const name = `jc-${url.pathname.replace(/\//g, "-")}`;
  const w = Math.min(1400, Math.floor(window.screen.availWidth * 0.7));
  const h = Math.min(1000, Math.floor(window.screen.availHeight * 0.85));
  const left = window.screenX + 40;
  const top = window.screenY + 40;
  const features = `popup=yes,noopener=no,noreferrer=no,width=${w},height=${h},left=${left},top=${top}`;
  const opened = window.open(url.toString(), name, features);
  if (opened) {
    rememberPopout({ path: url.pathname, x: left, y: top, w, h });
  }
};

const PopOutButton = () => (
  <button
    type="button"
    onClick={popOut}
    aria-label="Pop out this view to a separate window"
    title="Pop out to another monitor"
    data-testid="page-popout-btn"
    className="inline-flex items-center gap-1.5 h-9 px-3 rounded-sm border border-slate-200 bg-white hover:bg-slate-50 text-xs font-semibold text-slate-700 no-print"
  >
    <ExternalLink size={13} /> Pop out
  </button>
);

export const PageHeader = ({ eyebrow, title, description, actions, testId }) => {
  const popout = isPopoutMode();
  return (
    <div className="border-b border-slate-200 bg-white no-print" data-testid={testId}>
      <div className="px-4 md:px-8 py-5 md:py-6 flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
        <div className="flex-1 min-w-0">
          {eyebrow && (
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-blue-800 mb-2">
              {eyebrow}
            </div>
          )}
          <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-black tracking-tighter text-slate-900 break-words">
            {title}
          </h1>
          {description && (
            <p className="mt-2 text-sm md:text-base text-slate-600 max-w-2xl">{description}</p>
          )}
        </div>
        <div className="flex items-center gap-2 flex-wrap shrink-0">
          {actions}
          {!popout && <PopOutButton />}
        </div>
      </div>
    </div>
  );
};
